/* CLOVEBY — auto-moving carousels (trust band everywhere; categories, gallery & journal on mobile) */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mobile = window.matchMedia('(max-width: 749px)');
  var targets = [
    { sel: '.cb-trust--band .cb-trust__grid', speed: 32, mobileOnly: false },
    { sel: '.cb-cat-grid--circle', speed: 30, mobileOnly: true },
    { sel: '.cb-gallery-scroller .cb-scroller', speed: 30, mobileOnly: true },
    { sel: '.cb-journal', speed: 28, mobileOnly: true },
    { sel: '[data-subcats-track]', speed: 30, mobileOnly: true }
  ];
  var list = [];
  function setup(el, t) {
    if (el._cbAuto) return;
    var kids = [].slice.call(el.children);
    if (!kids.length) return;
    var st = { el: el, t: t, clones: [], paused: false, visible: true, resumeAt: 0, pos: el.scrollLeft };
    kids.forEach(function (k) {
      var c = k.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('is-visible');
      c.querySelectorAll('a,button,input').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      el.appendChild(c); st.clones.push(c);
    });
    el.setAttribute('data-cb-auto', '');
    function hold() { st.paused = true; }
    function release() { st.paused = false; st.resumeAt = performance.now() + 2500; st.pos = el.scrollLeft; }
    el.addEventListener('touchstart', hold, { passive: true });
    el.addEventListener('touchend', release, { passive: true });
    el.addEventListener('mouseenter', hold);
    el.addEventListener('mouseleave', release);
    el.addEventListener('focusin', hold);
    el.addEventListener('focusout', release);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { st.visible = en[0].isIntersecting; }).observe(el);
    }
    el._cbAuto = st;
    list.push(st);
  }
  function teardown(st) {
    st.clones.forEach(function (c) { c.remove(); });
    st.el.removeAttribute('data-cb-auto');
    st.el.scrollLeft = 0;
    st.el._cbAuto = null;
  }
  function scan() {
    targets.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) {
        var want = !t.mobileOnly || mobile.matches;
        if (want && !el._cbAuto) setup(el, t);
        else if (!want && el._cbAuto) { teardown(el._cbAuto); list = list.filter(function (s) { return s.el !== el; }); }
      });
    });
  }
  var last = performance.now();
  function tick(now) {
    var dt = Math.min(64, now - last); last = now;
    list.forEach(function (st) {
      if (st.paused || !st.visible || now < st.resumeAt || document.hidden) { st.pos = st.el.scrollLeft; return; }
      var first = st.el.children[0], clone = st.clones[0];
      if (!first || !clone) return;
      var loop = clone.offsetLeft - first.offsetLeft;
      if (loop <= 0 || st.el.scrollWidth <= st.el.clientWidth + 2) return;
      st.pos += st.t.speed * dt / 1000;
      if (st.pos >= loop) st.pos -= loop;
      st.el.scrollLeft = st.pos;
    });
    requestAnimationFrame(tick);
  }
  function start() { scan(); requestAnimationFrame(tick); }
  if (mobile.addEventListener) mobile.addEventListener('change', scan); else if (mobile.addListener) mobile.addListener(scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', scan);
})();
